export function urlStringToParsedUrlQuery(path, baseUrl) {
  var url = new URL(path, baseUrl);
  var params = {};
  url.searchParams.forEach(function (value, key) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]];
      }

      params[key].push(value);
    } else {
      params[key] = value;
    }
  });
  return params;
}